<script setup>
import { RouterView } from 'vue-router'
</script>

<template>
  <RouterView />
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: "App",

  watch: {
    items: {
      handler(val, oldVal) {
        console.log(oldVal + ' --> ' + val)
      },
      deep: true
    }
  },
});
</script>

<style>

.hkec-button {
  min-width: 88px;
  margin: 0 16px;
  border-radius: 5px;
  font-size: 16px;
}

.hkec-pagination {
  display: flex;
  padding-top: 16px;
}

#qrcode img {
  padding: 10px;
  background-color: white
}

.hkec-hidden {
  display: none;
  visibility: hidden
}

.hkec-action-button-box {
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);
}

.card-title-wrap {
  word-wrap: break-word !important;
  white-space: normal !important;
  overflow-wrap: break-word !important;
}

.v-card-text{
  font-size: 1rem !important;
}

</style>
